import { useMsal } from '@azure/msal-react';
import type { InteractionStatus } from '@azure/msal-browser';

/**
 * Exposes the current MSAL interaction status.
 */
const useMsalInteractionStatus = (): InteractionStatus => {
  const { inProgress } = useMsal();
  return inProgress;
};

export default useMsalInteractionStatus;
